export default 'M0 5c0-1.1.9-2 2-2h20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2V11a2 2 0 0 0-2-2H0zm13 7h4v11h-4zm-3 11H2a2 2 0 0 1-2-2v-9h10z';